import { Component, useEffect, useState } from 'react'
import Nav from './components/Nav'
import FloatingCompanion from './components/FloatingCompanion'
import VoiceButton from './components/VoiceButton'
import { NarrationProvider } from './audio/NarrationContext'
import Hero from './components/Hero'
import Experience from './components/Experience'
import Skills from './components/Skills'
import Projects from './components/Projects'
import Gallery from './components/Gallery'
import Story from './components/Story'
import Contact from './components/Contact'
import { SECTIONS } from './config'

class SectionBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { err: false }
  }

  static getDerivedStateFromError() {
    return { err: true }
  }

  render() {
    if (this.state.err) return null
    return this.props.children
  }
}

function useActiveSection() {
  const [active, setActive] = useState('home')
  useEffect(() => {
    const els = SECTIONS.map((s) => document.getElementById(s.id)).filter(Boolean)
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(entry.target.id)
        })
      },
      { rootMargin: '-50% 0px -50% 0px' }
    )
    els.forEach((el) => observer.observe(el))
    return () => observer.disconnect()
  }, [])
  return active
}

export default function App() {
  const active = useActiveSection()

  return (
    <NarrationProvider>
      <div className="relative">
        <Nav active={active} />
        <main>
          <SectionBoundary>
            <Hero />
          </SectionBoundary>
          <SectionBoundary>
            <Experience />
          </SectionBoundary>
          <SectionBoundary>
            <Skills />
          </SectionBoundary>
          <SectionBoundary>
            <Projects />
          </SectionBoundary>
          <SectionBoundary>
            <Gallery />
          </SectionBoundary>
          <SectionBoundary>
            <Story />
          </SectionBoundary>
          <SectionBoundary>
            <Contact />
          </SectionBoundary>
        </main>
        <VoiceButton active={active} />
        <FloatingCompanion active={active} />
      </div>
    </NarrationProvider>
  )
}
